// extracted by mini-css-extract-plugin
export default {"link":"useColumns_link__j3qYt","profileColumn":"useColumns_profileColumn__VJhtG"};